import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import AlertTable from './AlertTable'
import BrandedPageHeader from 'components/Layout/BrandedPageHeader'
import AlertRecordsPage from './AlertRecordsPage'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import DialogButton from 'components/Dialog/DialogButton'
import * as AlertDialog from 'components/Dialog/AlertDialog'

export default function Alerts() {
  const [searchParams] = useSearchParams()
  const showRecords = searchParams.get('showRecords') === 'true'
  const { userFilters = [] } = useSelector(state => state.filters)
  const { employerUserId } = useSelector(state => state.identity)

  const hasAvailableAlerts = employerUserId
    ? userFilters.some(k => k.filterType.name === 'Provider')
    : userFilters.length > 0

  return (
    <>
      <BrandedPageHeader>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant='h5' sx={{ color: 'white', fontWeight: 'bold' }}>
              {showRecords ? 'Alert Records' : 'My Alerts'}
            </Typography>
          </Grid>
          {!showRecords && (
            <Grid item>
              <DialogButton
                disabled={!hasAvailableAlerts}
                Module={AlertDialog}
                size='small'
                tooltip=''
                initialValues={{}}
                sx={{
                  py: 1.5,
                  px: 3,
                  backgroundColor: 'common.white',
                  color: 'primary.dark',
                  '&:hover': {
                    backgroundColor: 'common.white',
                    opacity: 0.9
                  }
                }}
              >
                Add Alert
              </DialogButton>
            </Grid>
          )}
        </Grid>
      </BrandedPageHeader>
      {showRecords ? <AlertRecordsPage /> : (
        <Box sx={{ maxWidth: '91.666667%', mx: 'auto', px: 2, mt: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='body1' sx={{
                color: 'common.white',
                mb: { xs: 2, md: 0 },
                whiteSpace: 'normal',
                wordBreak: 'normal',
                opacity: 0.9
              }}>
                Set up email alerts based on your saved filters to get notified about new opportunities
                that match your criteria. Stay informed and never miss a relevant match.
              </Typography>
            </Grid>
            {!hasAvailableAlerts && (
              <Grid item xs={12}>
                <Typography variant='body2' color='textSecondary' sx={{ mb: 2 }}>
                  Please save an eligible filter before adding an alert.
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <AlertTable />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  )
}
